module.exports = __webpack_public_path__ + "img/acmedcont2.5bbd5c01.png";